import gsap from 'gsap';

function initBackToTopButton() {
    /** @type {HTMLElement} */
    const backToTop = document.getElementById("back-to-top");

    // Show or hide the button based on scroll position
    function handleScroll() {
        if (window.scrollY > 20) {
            backToTop.style.display = "block";
        } else {
            backToTop.style.display = "none";
        }
    }

    // Scroll to the top smoothly when the button is clicked
    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    if (backToTop !== null) {
        // Element exists, so you can safely use it
        window.addEventListener("scroll", handleScroll);
        backToTop.addEventListener("click", scrollToTop);
    }
}

// Company location map with Mapbox
function initMap() {
    const mapContainer = document.getElementById('map');

    if (!mapContainer || typeof mapboxgl === 'undefined') {
        return;
    }

    mapboxgl.accessToken = 'pk.eyJ1IjoicnBiYWd1aW9kZXYiLCJhIjoiY20zYjA0ZnowMWZhdTJsb2xrbGZ2ZnlwZyJ9.AuwftSMNH4sEDZUGz87hvw';
    const map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/outdoors-v12',
        center: [123.92177373944861,10.365955965569654],
        zoom: 12
    });

    // Place a marker with popup
    new mapboxgl.Marker({color: 'red'})
        .setLngLat([123.92177373944861,10.365955965569654])
        .setPopup(new mapboxgl.Popup().setHTML('<h6>Edulearn Technologies, Inc.</h6><p>La Citadella Block 1 Lot 14B4, Cadahuan, Talamban, Cebu City.</p>'))
        .addTo(map);

    // Disable scroll zoom
    map.scrollZoom.disable();

    // Enable double click to zoom
    map.doubleClickZoom.enable();
}

// Initialize Modules on DOM Content Loaded
document.addEventListener('DOMContentLoaded', () => {
    initBackToTopButton();
    initMap();
});

const menuToggle = document.getElementById('menuToggle');
const closeButton = document.getElementById('closeBtn');
const navigationOverlay = document.getElementById('navOverlay');

if (menuToggle && closeButton && navigationOverlay) {
    const menuLinks = navigationOverlay.querySelectorAll('.menu-items a');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const menuTimeline = gsap.timeline({
        paused: true,
        defaults: {
            ease: 'power3.inOut',
        },
        onComplete: () => {
            closeButton.focus({ preventScroll: true });
        },
        onReverseComplete: () => {
            document.documentElement.classList.remove('nav-open');
            document.body.classList.remove('nav-open');
            navigationOverlay.setAttribute('aria-hidden', 'true');
            menuToggle.setAttribute('aria-expanded', 'false');
            menuToggle.focus();
        },
    });

    gsap.set(navigationOverlay, {
        autoAlpha: 0,
        xPercent: 100,
    });
    gsap.set(closeButton, {
        autoAlpha: 0,
        rotation: -45,
    });
    gsap.set(menuLinks, {
        autoAlpha: 0,
        x: 40,
    });

    menuTimeline
        .to(navigationOverlay, {
            autoAlpha: 1,
            xPercent: 0,
            duration: reduceMotion ? 0 : 0.5,
        })
        .to(closeButton, {
            autoAlpha: 1,
            rotation: 0,
            duration: reduceMotion ? 0 : 0.3,
        }, '<0.18')
        .to(menuLinks, {
            autoAlpha: 1,
            x: 0,
            duration: reduceMotion ? 0 : 0.4,
            stagger: reduceMotion ? 0 : 0.055,
        }, '<0.02');

    const openNavigation = () => {
        document.documentElement.classList.add('nav-open');
        document.body.classList.add('nav-open');
        navigationOverlay.setAttribute('aria-hidden', 'false');
        menuToggle.setAttribute('aria-expanded', 'true');
        menuTimeline.restart();
    };

    const closeNavigation = () => {
        menuTimeline.reverse();
    };

    menuToggle.addEventListener('click', openNavigation);
    closeButton.addEventListener('click', closeNavigation);

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menuTimeline.progress() > 0) {
            closeNavigation();
        }
    });
}
